export default __webpack_public_path__ + "static/media/review-3.c2168d20.png";